<span
  class="app-link-container"
  [routerLink]="disabled || external ? null : route"
  [ngClass]="{ 'pm-link-disabled': disabled, external: external }"
  (click)="onOpenExternalLink()"
>
  <ng-content></ng-content>
</span>
